export default __webpack_public_path__ + "static/media/kv@1.5.20cc3c0d.jpg";